export function ProgramPhaseActionItemPlaceholder() {
  return (
    <div className="border-t-1 border-brand-800 md:rounded-sm md:border-1 p-4 flex h-full animate-pulse">
      <div className="w-8 h-8 bg-brand-100 rounded-full" />
      <div className="px-4 flex-1">
        <div className="h-3 bg-brand-100 rounded w-1/2 mb-2"></div>
        <div className="h-3 bg-brand-100 rounded w-full"></div>
      </div>
      <div className="ml-auto w-24 h-8 bg-brand-100 rounded-lg" />
    </div>
  );
}

export default ProgramPhaseActionItemPlaceholder;

